import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: "#2691d9",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    color: "black",
    textTransform: "uppercase",
    minWidth: 72,
    fontWeight: 700,
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "sans-serif",
      "Apple Color Emoji",
      "Segoe UI Emoji",
      "Segoe UI Symbol",
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&$selected": {
      color: "#1890ff",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#40a9ff",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(1),
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
  }
}));

export default function CustomizedTabs({ mode, setMode }) {
  const classes = useStyles();
  const [value, setValue] = useState(mode === "speciesTable" ? 0 : 1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    newValue === 0 && setMode("speciesTable");
    newValue === 1 && setMode("obsPeriodTable");
  };

  return (
    <div className={classes.root}>
      <div className={classes.demo1}>
        <AntTabs value={value} onChange={handleChange} aria-label="ant-tab">
          <AntTab id="speciesButton" label="Lajit" />
          <AntTab id="periodsButton" label="Jaksot" />
        </AntTabs>
        <Typography className={classes.padding} />
      </div>
    </div>
  );
}

CustomizedTabs.propTypes = {
  mode: PropTypes.oneOf(["speciesTable", "obsPeriodTable"]).isRequired,
  setMode: PropTypes.func.isRequired
};
